import React from "react";
import { useTranslation } from "react-i18next";
import '@progress/kendo-theme-default/dist/all.css';
import {
    ModalTitle,
    ModalButton
} from "pages/People/PeopleStyled";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import SpinnerIcon from "assets/svgIcons/SpinnerIcon";

const PeopleAlertModal = React.memo(({ openPeopleAlertModalOpen, yesCallbackFunction, noCallbackFunction, title, content, loading, isMessageOnly }) => {
    const { t } = useTranslation();

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: '#ffffff',
        border: '2px solid #ccc',
        boxShadow: 24,
        p: 4,
    };

    const noButtonStyle = {
       marginRight: 10,
       height: 35,
       padding: 10,  
       backgroundColor: '#ccc', 
       color: 'white', 
       border: 'solid 1px #ccc'
    }

    const disableButtonStyle = {
       marginRight: 10,
       height: 35,
       padding: 10,  
       backgroundColor: '#ccc', 
       color: 'white', 
       border: 'solid 1px #ccc',
       cursor: 'not-allowed'
    }

    return (<Modal 
                open={openPeopleAlertModalOpen}
                aria-labelledby="modal-title"
                aria-describedby="modal-description">
                    <Box sx={modalStyle}>
                       <ModalTitle>
                            {title}
                        </ModalTitle> 

                        {content}      
                        
                         <ModalButton>
                            <>
                                {loading &&
                                    <span style={{margin: 10}}><SpinnerIcon width={20} height={20} /></span>
                                }
                                {!isMessageOnly &&
                                    <>
                                        <button onClick={() => noCallbackFunction()} 
                                                disabled={loading}
                                                style={!loading ? noButtonStyle : disableButtonStyle}>
                                                {t("No")}
                                        </button>
                                        <button onClick={() => yesCallbackFunction()}
                                                disabled={loading}
                                                style={!loading ? { height: 35, padding: 10, backgroundColor: '#bc9b6a', color: 'white', border: 'solid 1px #ccc' } : disableButtonStyle}>
                                                    {t("Yes")}
                                        </button>
                                    </>
                                }
                                {isMessageOnly &&
                                    <button onClick={() => noCallbackFunction()}
                                            disabled={loading}
                                            style={!loading ? { height: 35, padding: 10, backgroundColor: '#bc9b6a', color: 'white', border: 'solid 1px #ccc' } : disableButtonStyle}>
                                                {t("Ok")}
                                    </button>
                                }
                            </>
                        </ModalButton>               
                    </Box>
            </Modal>
    );
});

export default PeopleAlertModal;
